'use client';

import type { PropertyDetailListing } from '@/src/components/features/property/types';
import { useIsDesktop, useViewportActivation } from '@/src/lib/hooks/ui';
import { NeighborhoodProvider } from './context';
import { NeighborhoodSpokeContent } from './NeighborhoodSpoke';
import { inlineDetailBody } from './spokes/neighborhoodSpoke.styles';

type Props = {
  listing: PropertyDetailListing;
};

export const NeighborhoodModule = ({ listing }: Props) => {
  const isDesktop = useIsDesktop();
  // The spoke mounts eagerly (its map placeholder matches the map's height, so
  // the script-load swap cannot shift layout); only the Google Maps script
  // load waits for the module to approach the viewport.
  const { ref, isActive } = useViewportActivation<HTMLDivElement>({ disabled: isDesktop });

  return (
    <div ref={ref}>
      <NeighborhoodProvider>
        <NeighborhoodSpokeContent
          listing={listing}
          showHeader={false}
          bodyClassName={inlineDetailBody}
          collapseDetails
          mapLoadEnabled={isDesktop || isActive}
        />
      </NeighborhoodProvider>
    </div>
  );
};
